import Gobalstore from "../index";
export const actions = {
  /* Category */
  getCategories: function (localStore, sec_code) {
    return new Promise((resolve, reject) => {
      this.axios({
        method: "GET",
        url: `/business/guarded/category/${sec_code}`,
      })
        .then(function (response) {
          localStore.commit("setCatagories", response.data);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getDocCheckList: function (localStore, entId) {
    this.axios({
      method: "GET",
      url: `/business/guarded/cate/doc-checklist/${entId}`,
    }).then(function (response) {
      localStore.commit("setDocChecklist", response.data);
    });
  },
};
